import { Layout } from 'antd';
import { Link } from 'react-router-dom';
import { DeliveryIcon } from '../../../store/icon';
import { useEffect, useState } from 'react';
import { emitter, getStoreOrders } from '../../../store/StoreUtils';

const { Header } = Layout;

const CustomOrderHeader = () => {
  const [counter, setCounter] = useState(0);

  const getOrderCount = () => {
    const orders = getStoreOrders();
    setCounter(orders.length || 0);
  };

  useEffect(() => {
    getOrderCount();
    emitter.addListener(
      'localOrderChange',
      () => {
        getOrderCount();
      },
      null
    );
  }, []);

  return (
    <Header
      style={{
        background: '#fff',
        padding: '0px 24px',
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <div className="logo">
        <Link to="/">
          <DeliveryIcon />
          <span className="title"> My Delivery</span>
        </Link>
      </div>
      {counter ? <Link to="/customer-order/list">Хадгалсан захиалга ({counter})</Link> : null}
    </Header>
  );
};

export default CustomOrderHeader;
